export const convertBirthTime = (value) => {
    let hour = value?.split(':')[0];
    let minute = value?.split(':')[1];
    // Determine if it's AM or PM
    let period = hour >= 12 ? "PM" : "AM";
    
    // Convert the hour from 24-hour to 12-hour format
    hour = hour % 12;
    if (hour === 0) {
        hour = 12; // 12 AM or 12 PM (noon)
    }
    
    // Format the minute to always show two digits
    minute = minute < 10 ? '0' + minute : minute;
    
    // Return the time in the AM/PM format
    return `${hour}:${minute} ${period}`;
}